import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReweComponent } from './simple-icons-rewe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReweComponent ],
    exports:      [ SimpleIconsReweComponent ],
    bootstrap:    []
})
export class SimpleIconsReweModule {}
